(function() {
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize all background videos
      const videoElements = document.querySelectorAll('.video-js.myVideo');
      console.log(videoElements);
    videoElements.forEach(videoElement => {
      const player = videojs(videoElement.id, {
        autoplay: false,
        muted: true,
        loop: true,
        controls: false,
        fluid: false,
        fill: true,
        responsive: true
      });

      // Manually trigger playback when the player is ready
      player.ready(() => {
        player.loop(true);
        player.play().catch(error => {
          console.log("Autoplay blocked:", error);
        });
      });

      // Additional fallback for visibility changes
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          player.play().catch(error => {
            console.log("Playback failed on visibility change:", error);
          });
        }
      });

      // Handle Shopify theme editor
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.contains(videoElement)) {
            player.play().catch(error => {
              console.log("Playback failed after section load:", error);
            });
          }
        });
      }
    });
  });
})(); 